import { FC, useMemo, useCallback } from 'react'
import { OuterEvent } from 'components/features/pfm/OuterEvent/OuterEvent'
import styles from 'components/features/pfm/ExpandableAnnotation/ExpandableAnnotation.styl'
import cn from 'classnames'
import { RectOffset } from 'helpers/DOMHelpers'

type ExpandableAnnotationProps = {
  offset: RectOffset
  isShown: boolean
  onClose?: (event: KeyboardEvent) => void
}

export const ExpandableAnnotation: FC<ExpandableAnnotationProps> = ({
  children,
  offset,
  isShown,
  onClose,
}) => {

  const className = useMemo(() => cn(
    styles.annotation,
    isShown && styles.expanded,
  ), [isShown])

  const handleClose = useCallback<(event: KeyboardEvent) => void>((event) => {
    if (onClose && isShown) {
      onClose(event)
    }
  }, [onClose, isShown])

  return (
    <OuterEvent
      className={ className }
      style={{
        ...(offset ? { transformOrigin: `${ offset.left }px ${ offset.top }px` } : {}),
      }}
      onOuterTap={ handleClose }
      onOuterClick={ handleClose }
      onOuterESC={ handleClose }
    >
      { children }
    </OuterEvent>
  )
}
